// Core
import { useState, useEffect, useCallback } from 'react';
import { Box, Flex, Text, Button, useDisclosure } from '@chakra-ui/react';
import { useSpring, animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { RiMessage3Fill, RiProfileFill } from 'react-icons/ri';
import { FaHeart, FaHeartBroken, FaUser, FaCheckCircle} from 'react-icons/fa';
import { IoLocationSharp, IoCloseOutline } from 'react-icons/io5';
import { IoIosClose } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import { MdFilterList } from 'react-icons/md';
import { useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import placeholderUser from 'assets/img/placeholder-user.png';
import { textLang } from 'services/Lang';

// Components
import StorySlider from './components/StorySlider';
import BirthInfo from './components/BirthInfo';
import MatchInfo from './components/MatchInfo';
import BalanceModal from './components/modals/Balance';
import MatchModal from './components/modals/Match';
import SuperLikeModal from './components/modals/SuperLike';

const MatchPeople = ({object}) => {
  const [active, setActive] = useState(0);
  const [showInfo, setShowInfo] = useState(0);

  const colorMatch = 'white';

  const [isAnimateDislike, setIsAnimateDislike] = useState(false);
  const handleDislike = (index) => {
    if(isAnimateDislike){ return; }
    setIsAnimateDislike(true);
    setTimeout(function() {
      setActive(index === 20 ? 0 : index );
      setIsAnimateDislike(false);
    }, 400);
  };

  const [isAnimateLike, setIsAnimateLike] = useState(false);
  const handleLike = (index) => {
    if(isAnimateLike){ return; }
    setIsAnimateLike(true);
    setTimeout(function() {
      setActive(index === 20 ? 0 : index );
      setIsAnimateLike(false);
    }, 400);
  };

  const [people, setPeople] = useState([]);
  const limit = 20;
  const [offset, setOffset] = useState(0);

  const [isFetchingErrors, setIsFetchingErrors] = useState();
  const [globalSearch, setGlobalSearch] = useState(false);
  const { refetch, isFetching } = useQuery({
    queryKey: ['data-me', offset, globalSearch, object?.findFor, object?.findGender, object?.findAge],
    queryFn: async () => {
      const params = {
        offset,
        limit,
        ...(object?.findFor && { findFor: object.findFor }),
        ...(object?.findGender && { findGender: object.findGender }),
        ...(object?.findAge && { findAge: object.findAge }),
        ...(globalSearch && { global: globalSearch }),
      };

      const response = await apiService.getUsers(params);
      if (response.statusCode !== 200) {
        setIsFetchingErrors(response.message);
        setPeople([]);
        return true;
      }

      setIsFetchingErrors(undefined);
      setPeople(response.data);
      return true;
    },
    enabled: !!object, 
    refetchOnWindowFocus: false,
    retry: false,
  });

  useEffect(() => {
    console.log(active);
    if (active === 19 && active !== 0) {
      setOffset(offset + limit);
      setActive(0);
    }
  }, [active]);

  const setDisLike = useCallback(async (objectId) => {
    try {
      await apiService.dislike({id: objectId});
    } catch (e){}
    return true;
  });

  const { isOpen: isOpenMatch, onClose: onCloseMatch, onOpen: onOpenMatch } = useDisclosure();
  const setLike = useCallback(async (objectId) => {
    try {
      const response = await apiService.like({id: objectId});
      if(response.statusCode === 200){
        
        const match = response.data;
        if(match){
          onOpenMatch();
        } else {
          handleLike(active + 1);
        }
      } else {
        onOpenBalance();
      }
    } catch (e){
      onOpenBalance();
    }

    return true;
  });

  const { isOpen: isOpenSuperLike, onClose: onCloseSuperLike, onOpen: onOpenSuperLike } = useDisclosure();
  const setSuperLike = useCallback(async (objectId) => {
    try {
      const response = await apiService.superLike({id: objectId});
      if(response.statusCode === 200){
        
        const match = response.data;
        if(match){
          onOpenSuperLike();
        } else {
          handleLike(active + 1);
        }
      } else {
        onOpenBalance();
      }
    } catch (e){
      onOpenBalance();
    }

    return true;
  });

  const history = useHistory();
  const { isOpen: isOpenBalance, onClose: onCloseBalance, onOpen: onOpenBalance } = useDisclosure();
  const handleBalance = async () => {
      onCloseBalance();
      history.push('/profile/balance');  
  };

  const handleMatch = async () => {
      onCloseMatch();
      history.push(`/messages/${people[active]?.id}`); 
  };

  const handleNextMatch = async () => {
      handleLike(active + 1);
  };

  return (
    <Box position="relative">
    
    { isFetching && 
      <Box
        width="100%"
        height="100vh"
        textAlign="center"
        position="relative">
        <Box 
          w="100%" 
          bottom="80px" 
          h="40vh" 
          overflow="hidden" 
          position="fixed"
          zIndex="3"
        >
          <Text px="10%" variant="title-lg" fontSize="24px">
          {textLang('match_user_looking')}
          </Text>
        </Box>
      </Box>
    }

    <Box 
      zIndex="999"
      position="absolute"
      transform="translate(-50%, 0px)"
      left="50%"
      mt="58px"
      w="180px"> 
        <Button 
          variant={ globalSearch ? 'button-sm' : 'solid-sm'}
          onClick={() => setGlobalSearch(!globalSearch)}
          rightIcon={
            <FaCheckCircle 
              color={ globalSearch ? '#0fe30b' : 'rgb(255, 65, 51)'}
            />
          }>{textLang('global_search')}</Button>
    </Box>

    {(
      (!isFetching && Array.isArray(people) && people.length === 0) ||
      (!isFetching && people[active]?.id === undefined)
    ) && (
      <Box
        width="100%"
        height="100vh"
        textAlign="center"
        position="relative">
        <Box 
          w="100%" 
          bottom="80px" 
          h="40vh" 
          overflow="hidden" 
          position="fixed"
          zIndex="3"
        >
          <Text px="10%" variant="title-lg" fontSize="24px">
            { isFetchingErrors ? textLang(isFetchingErrors) : textLang('match_user_filters')}
          </Text>
        </Box>
      </Box>
    )}

    { !isFetching && Array.isArray(people) && people?.length > 0 && people[active]?.id &&
    <Box>
      <Box bg="#6e7af0" 
          filter="blur(240px)" w="50%" h="140px" left="0%" borderRadius="full"
          transform="translate(-50%, 40px)" position="absolute" zIndex="-1" />

      <Box
        width="100%"
        height="100vh"
        position="relative"
        transform={isAnimateDislike ? 'translateX(100px)' : isAnimateLike ? 'translateX(-100px)' : 'translateX(0px)'}
        opacity={isAnimateDislike ? '0' : isAnimateLike ? '0' : '1'}
        transition="opacity 0.5s ease-out, transform 0.5s ease-out"
        willChange="opacity, transform"
        >
        <Box 
          w="100%" 
          bottom="80px" 
          h="80vh" 
          overflow="hidden" 
          transform = { isAnimateDislike ? 'scale(0.76) rotate(10deg)' : isAnimateLike ? 'scale(0.76) rotate(-10deg)' : 'scale(0.85) rotate(5deg)'}
          transition="transform 0.5s ease-out"
          willChange="transform"
          borderRadius="30px"
          position="fixed"
          zIndex="3"
        >
          <StorySlider images={[people[active]?.image]} />
          
          <Box p="24px" position="fixed" bottom="0px" w="100%" bg="linear-gradient(0deg, black, transparent)">
            <Flex
              bg="#00000033"
              width="max-content"
              padding="4px 8px"
              borderRadius="4px"
              backdropFilter="blur(4px)"
              gap="4px" alignItems="center">
              <IoLocationSharp color="#E1E1E1" fontSize="16px" />
              <Text variant="text-xs" color={colorMatch} textShadow="0.5px 0.5px black">{people[active]?.country}, {people[active]?.city}</Text>
            </Flex>

            <Flex justifyContent='start' gap="8px" alignItems='center' w="100%">
              <Text variant='title-xl' color={colorMatch} textShadow="1px 1px black">{people[active]?.firstName}</Text>
              <Box onClick={() => setShowInfo(true)}>
                <RiProfileFill color={colorMatch} fontSize="36px" />
              </Box>
            </Flex>

            { people[active]?.birthday &&
              <BirthInfo birthDate={people[active]?.birthday} />
            }

            { people[active]?.description &&
              <Text 
                variant="text-md"
                color={colorMatch} 
                mt="16px"
                sx={{
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  overflow: 'hidden',
                }}
              >
                {people[active].description}
              </Text>
            }
            
            { people[active]?.interests &&
              <Flex gap='8px' mt='12px' flexWrap='wrap'>
                {people[active].interests.map((item, index) => (
                  <Box className='tag-interests' color={colorMatch} key={index}>{textLang(item)}</Box>
                ))}
              </Flex>
            }
          </Box>
        </Box>

        <Box 
          w="100%" 
          bottom="80px" 
          h="80vh" 
          overflow="hidden" 
          transform = { isAnimateDislike ? 'scale(0.7) rotate(10deg)' : isAnimateLike ? 'scale(0.7) rotate(-10deg)' : 'scale(0.85) rotate(2.5deg)'}
          transition="transform 0.3s ease-out"
          willChange="transform"
          borderRadius="30px"
          position="fixed"
          bg="rgb(255 121 111)"
          zIndex="2"
        />

        <Box 
          w="100%" 
          bottom="80px" 
          h="80vh" 
          overflow="hidden" 
          transform = { isAnimateDislike ? 'scale(0.7) rotate(10deg)' : isAnimateLike ? 'scale(0.7) rotate(-10deg)' : 'scale(0.85) rotate(0deg)'}
          transition="transform 0.3s ease-out"
          willChange="transform"
          borderRadius="30px"
          position="fixed"
          bg="#ffffffad"
          zIndex="1"
          boxShadow="12px 11px 19px #f2e3dfad"
        />

        <Box position="fixed" right="30px" bottom="30%" zIndex="999" overflow="visible !important">
          <Box
            className="unlike"
            onClick={() => { 
              setDisLike(people[active]?.id);
              handleDislike(active + 1);
            }}>
            <IoCloseOutline color="#535353" fontSize="32px" />
          </Box>

          <Box
            className="super-like"
            onClick={
              () => {
                setSuperLike(people[active]?.id);
                //handleLike(active + 1);
              }
            }>
            <FaHeartBroken color="rgb(255 255 255)" fontSize="32px" />
          </Box>

          <Box
            className="like"
            onClick={
              () => {
                setLike(people[active]?.id);
                //handleLike(active + 1);
              }
            }>
            <FaHeart color="rgb(255, 65, 51)" fontSize="32px" />
          </Box>
        </Box>
      </Box>

      <Box className="match-user-info" h={ showInfo ? '80%' : '0' }>
          <Box onClick={() => setShowInfo(false)} top="20px" right="10px" position="absolute">
            <IoIosClose fontSize="70px" />
          </Box>
          <MatchInfo item={people[active]} />
      </Box>
                
    </Box>
    }

    <BalanceModal
      handle={handleBalance}
      isOpen={isOpenBalance}
      onClose={onCloseBalance}
    />

    <MatchModal
      handle={handleMatch}
      handleNext={handleNextMatch}
      user={people[active]}
      isOpen={isOpenMatch}
      onClose={onCloseMatch}
    />

    <SuperLikeModal
      handle={handleMatch}
      handleNext={handleNextMatch}
      user={people[active]}
      isOpen={isOpenSuperLike}
      onClose={onCloseSuperLike}
    />

    </Box>
  );
};

export default MatchPeople;
